var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rest } from "../../Rest";
export class DeviceApiLegacy extends Rest {
    constructor(baseUrl, tenantToken, ciam_token, jwtToken) {
        super(`${baseUrl}/device-inventory/v1`);
        this.name = "DeviceApi";
        super.setCommonHeader("Authorization", `Bearer ${jwtToken}`);
        super.setCommonHeader("DIS_DES_AK_TENANT_TOKEN", tenantToken);
        super.setCommonHeader("X-DES-CONSUMER-IAM-TOKEN", ciam_token);
    }
    myDevices(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return typeof userId === "undefined"
                ? Promise.reject(new Error("User id is not defined"))
                : this.request(`/devices?userId=${userId}`, {
                    method: "GET",
                });
        });
    }
    registerDevice(registrationCode, userId, token, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userId === undefined) {
                return Promise.reject(new Error("Consumer ID is not defined"));
            }
            return this.request("/devices", {
                headers: Object.assign(Object.assign({}, (!!token && { Authorization: `Bearer ${token}` })), (!!ciam_token && { "X-DES-CONSUMER-IAM-TOKEN": ciam_token })),
                method: "POST",
                body: JSON.stringify({ deviceId: registrationCode, consumerId: userId }),
            }, true);
        });
    }
    registerDeviceToGuest(deviceId, guestIdentifier) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request("/devices/guest", {
                method: "POST",
                body: JSON.stringify({ deviceId, externalId: guestIdentifier }),
            }, true);
        });
    }
    unassignDeviceFromGuest(deviceId, externalId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(`/devices/guest/${encodeURIComponent(deviceId)}/unassign`, {
                method: "PATCH",
                body: JSON.stringify({ externalId }),
            }, true);
        });
    }
    deleteDevice(id, userId, ciamToken) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userId === undefined) {
                return Promise.reject(new Error("Consumer ID is not defined"));
            }
            const overrideHeaders = ciamToken !== undefined ? { headers: { "X-DES-CONSUMER-IAM-TOKEN": ciamToken } } : {};
            return this.request(`/devices/${encodeURIComponent(id)}/unassign`, Object.assign({ method: "PUT", body: JSON.stringify({ consumerId: userId }) }, overrideHeaders), true);
        });
    }
    checkDeviceIdForRegistration(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(`/devices/validation/${id}`, { method: "GET" }, true);
        });
    }
    assignDeviceToUser(deviceId, userId, ciamToken) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userId === undefined) {
                return Promise.reject(new Error("Consumer ID is not defined"));
            }
            const overrideHeaders = ciamToken !== undefined ? { headers: { "X-DES-CONSUMER-IAM-TOKEN": ciamToken } } : {};
            return this.request(`/devices/${deviceId}/consumer`, Object.assign({ method: "PATCH", body: JSON.stringify({ consumerId: userId }) }, overrideHeaders), true);
        });
    }
}
//# sourceMappingURL=DeviceApiLegacy.js.map